import { ISaveBar } from '@/types/components/savebar';
import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

const initialState: ISaveBar = {
    isShowSaveBar: false,
    isLoadingSaveBar: false,
    isDisableSaveBar: false,
    isCheckSave: false,
    isCheckingTimeSlot: false,
    isDiscard: false,
};

const saveBarSlice = createSlice({
    name: 'saveBar',
    initialState,
    reducers: {
        handleSetSaveBar: (state, action: PayloadAction<Partial<ISaveBar>>) => {
            return { ...state, ...action.payload };
        },
        handleResetSaveBar: (state) => {
            state.isShowSaveBar = false;
            state.isLoadingSaveBar = false;
            state.isDisableSaveBar = false;
            state.isCheckSave = false;
            state.isCheckingTimeSlot = false;
            state.isDiscard = false;
        }
    },
});

export const saveBarSelector = createSelector((state: RootState) => state.saveBar, (state) => state);

export const { handleSetSaveBar, handleResetSaveBar } = saveBarSlice.actions

export default saveBarSlice